import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { apiPath, RoutePath } from "../../utility/Constant";

const BlogCreate = () => {
  const { blogListApi } = apiPath;
  const { blogList } = RoutePath;
  const navigate = useNavigate();

  const dynamicDetailData = [];
  [1].map((item, index) => {
    dynamicDetailData.push({
      label: `Detail ${index}`,
      type: "text",
      name: "",
      defaultValue: item,
      required: false,
    });
  });

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "file",
      name: "img",
      required: true,
    },
    {
      elementType: "input",
      label: "Blog Title",
      type: "Text",
      name: "blogTitle",
      required: true,
    },
    {
      elementType: "select",
      label: "Blog Category",
      type: "Text",
      name: "category",
      required: true,
      options: ["News", "Blog", "Event"],
    },
    {
      elementType: "input",
      label: "Main Description Title",
      type: "Text",
      name: "mainDescriptionTitle",
      required: true,
    },
    {
      elementType: "input",
      label: "Author Title",
      type: "Text",
      name: "author",
      required: true,
    },
    {
      elementType: "input",
      label: "Date",
      type: "date",
      name: "date",
      required: false,
    },
    {
      elementType: "textField",
      label: "Main Description",
      type: "Text",
      name: "mainDescription",
      required: true,
    },
  ];

  const multiDimensionalMultipleData = [
    {
      elementType: "nestedMultiple",
      label: "Blog Details",
      name: "description",
      multipleData: dynamicDetailData,
      multiple: true,
      required: false,
    },
  ];
  const useData = data.concat(multiDimensionalMultipleData);

  const update = (data) => {
    updateData(blogListApi, data, false, null, null, true);
    setTimeout(() => {
      navigate("/" + blogList);
    }, 1000);
  };

  return (
    <div>
      <GlobalForm
        data={useData}
        multiDimensionalMultipleData={multiDimensionalMultipleData}
        update={update}
      />
    </div>
  );
};

export default BlogCreate;
